import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TicketService } from '../services/ticket.service';
import { SpecialService } from '../services/special.service';
import { Ticket } from '../models/ticket.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'search-tickets',
  templateUrl: '../views/core/search-tickets.html',
  providers: [TicketService,SpecialService]
})
export class SearchTicketsComponent{
  public title: string;
  public tickets: Ticket[];
  public cfounds: any[];
  public txtSearch:string;
  public message: any;
  public searching:boolean;
  public collectorSelected:boolean;
  public contract_id:number;
  public customer_name:string;
  public wait:boolean;
  public contractPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private ticketService: TicketService,
    public sharedVariables: VariableService,
    public specialService: SpecialService
  )
  {
      this.title = null;
      this.wait = true;
      this.contractPrivilege = null;
  }
  ngOnInit()
  {
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getAllTickets();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllTickets()
  {
    this.ticketService.getTickets().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",this.contractPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  getAllTicketsByCustomerName(name:string)
  {
    this.ticketService.getAllTicketsByCustomerName(name).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.tickets = null;
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getAllTicketsByFolio(folio:number)
  {
    this.ticketService.getAllTicketsByFolio(folio).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.tickets = null;
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getAllTicketsByContract(contract_id:number)
  {
    this.ticketService.getAllTicketsByContract(contract_id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.tickets = null;
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getAllTicketsByCollector(collector:string)
  {
    this.ticketService.getAllTicketsByCollector(collector).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
          this.tickets = null;
        }else{
          this.tickets = result.data;
          console.log(this.tickets);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/search-tickets.component.ts